import DesignNotificationEvent, { EstimateNotificationEvent, PrescriptionNotificationEvent } from './EventTypeEnum';

export const DesignEventGroups = {
    drawingNotifications: [
        DesignNotificationEvent.DrawingStatusesChange,
        DesignNotificationEvent.DrawingDataRolesAssignment,
        DesignNotificationEvent.DrawingAnnotationsCreation,
        DesignNotificationEvent.DrawingAnnotationsChange,
        DesignNotificationEvent.DrawingAnnotationsByGroupMove,
        DesignNotificationEvent.DrawingAnnotationsFulfillment,
        DesignNotificationEvent.DrawingAnnotationsNewMessage,
        DesignNotificationEvent.DrawingAcceptReturnRequest,
        DesignNotificationEvent.DrawingRejectReturnRequest,
        DesignNotificationEvent.DrawingCreateReturnRequest,
        DesignNotificationEvent.DrawingExpirationDate,
        DesignNotificationEvent.DrawingDelete,
    ] as const,

    tasksNotifications: [
        DesignNotificationEvent.TasksAssignment,
        DesignNotificationEvent.TasksDataChange,
        DesignNotificationEvent.TasksStatusChange,
        DesignNotificationEvent.TasksNewMessages,
        DesignNotificationEvent.TasksFulfillment,
        DesignNotificationEvent.TasksDeadlineChange,
        DesignNotificationEvent.TasksCreate,
        DesignNotificationEvent.TasksDeleteAuthorTask,
    ] as const,
} as const;

export type EventGroupName = keyof typeof DesignEventGroups;

export type EventTypeByGroup<G extends EventGroupName> = typeof DesignEventGroups[G][number];

export const PrescriptionEventGroups = {
    main: [
        PrescriptionNotificationEvent.ChangeDeadline,
        PrescriptionNotificationEvent.ChangeListExecutors,
        PrescriptionNotificationEvent.ChangePrescriptionInfo,
        PrescriptionNotificationEvent.ChangePrescriptionStatus,
        PrescriptionNotificationEvent.ChangeRemarkStatus,
        PrescriptionNotificationEvent.CreatePrescription,
        PrescriptionNotificationEvent.SendPrescriptionOverdue,
        PrescriptionNotificationEvent.ChangePrescriptionAct,
    ],
} as const;

export const EstimateEventGroups = {
    main: [EstimateNotificationEvent.ChangeEstimateStatus, EstimateNotificationEvent.SendChatMessage],
} as const;
